// src/app/shared/pipe/filtroPermiso.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroPermiso',
  standalone: true
})
export class FiltroPermisoPipe implements PipeTransform {
  transform(permisos: any[], filtro: string): any[] {
    if (!filtro || !permisos) return permisos;

    const filtroLower = filtro.toLowerCase();
    return permisos.filter(permiso =>
      permiso.nombreRuta.toLowerCase().includes(filtroLower)
    );
  }
}
